import { BuildingLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Forms = [
  {
    fileStoreId: "decd33d2-0d47-481b-ac44-547934f0059d",
    label: "Building Application Form",
  },
  {
    fileStoreId: "75399301-ee30-483d-bd96-38da2582cf48",
    label: "Notice of Completion(Upto plinth level)",
  },
  { fileStoreId: "a0afb271-a575-4d8d-a495-9dd754890e17", label: "Annex G" },
  {
    fileStoreId: "6caa8d82-6733-455f-83fb-87f46b551985",
    label: "Notice of Completion",
  },
  {
    fileStoreId: "c5c7f0b9-0f2e-421f-8727-16921cb37c35",
    label: "Notice of Inspection of Drainage Form",
  },
  {
    fileStoreId: "008d21b4-d947-4697-98ef-1fc315bfba6c",
    label: "Declaration Form",
  },
  {
    fileStoreId: "ab4b141f-bb7a-4b87-bd40-b1529da4ef5b",
    label: "General Undertaking Form",
  },
  {
    fileStoreId: "997168c1-35db-4148-8128-78f2483a9807",
    label: "Indemnity Form",
  },
  {
    fileStoreId: "ae5e2b30-cae3-45cf-9c33-f22570f11cc7",
    label: "Notice of Commencement Form",
  },
  {
    fileStoreId: "866cccff-a10c-42c5-aa9c-695c3777f9b5",
    label: "Composite Declaration Form",
  },
];

const Building_Sanction_Download_Forms = () => (
  <TableStructure
    title="Download Forms"
    heading={"Forms List"}
    list={Forms}
    leftMenuList={BuildingLeftMenuList}
    longMenuList={true}
  />
);

export default Building_Sanction_Download_Forms;
